<div *ngIf="(store$ | async) as store" class="h-100">
  <ng-ecr-requests [loading]="store.state.loading" [requests]="store.state.data">
  </ng-ecr-requests>
</div>
